import { AdminLandingPage } from '@storefronts/common-types'
import React, { Dispatch, SetStateAction } from 'react'

type LandingPageEditorOverrideContext = {
    initialLandingPage: AdminLandingPage
    setInitialLandingPage: Dispatch<
        SetStateAction<AdminLandingPage | undefined>
    >
    stagedLandingPage: AdminLandingPage
    setStagedLandingPage: Dispatch<SetStateAction<AdminLandingPage>>
    /**
     * Hashes the merchant has explicitly removed from Storefront Products
     * during this editor session. Passed to `syncStorefrontProductsFromCatalog`
     * as `excludeHashes` so append-only sync does not silently re-attach a
     * product a merchant removed while a section still references it.
     * Consumers call `recordProductRemovals` / `recordProductAdditions` from
     * the modal/picker paths to keep this set accurate.
     */
    sessionRemovedProductHashes: Set<string>
    recordProductRemovals: (linkHashes: string[]) => void
    recordProductAdditions: (linkHashes: string[]) => void
    isLandingPageChanged: () => boolean
    isButtonConfigValid: () => boolean
    isDesktopRedirectOverrideValid: () => boolean
    isPreviewMode: boolean
    setIsPreviewMode: (newPreviewMode: boolean) => void
}

const defaultOverridesContext: LandingPageEditorOverrideContext = {
    initialLandingPage: {} as AdminLandingPage,
    setInitialLandingPage: () => {},
    stagedLandingPage: {} as AdminLandingPage,
    setStagedLandingPage: () => {},
    sessionRemovedProductHashes: new Set<string>(),
    recordProductRemovals: () => {},
    recordProductAdditions: () => {},
    isLandingPageChanged: () => false,
    isButtonConfigValid: () => true,
    isDesktopRedirectOverrideValid: () => true,
    isPreviewMode: false,
    setIsPreviewMode: () => {},
}

export const LandingPageEditorOverrideContext =
    React.createContext<LandingPageEditorOverrideContext>(
        defaultOverridesContext,
    )
